(function () {
  'use strict';

  var DESKTOP_MQ = window.matchMedia('(min-width: 720px)');

  function equalizeColumn(cards) {
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.style.minHeight = '';
    });

    if (!DESKTOP_MQ.matches) return;

    var maxHeight = 0;
    cards.forEach(function (card) {
      maxHeight = Math.max(maxHeight, card.offsetHeight);
    });

    if (maxHeight <= 0) return;

    cards.forEach(function (card) {
      card.style.minHeight = maxHeight + 'px';
    });
  }

  function equalizeContainer(container) {
    var cards = container.querySelectorAll('.vatpan-feature-card');
    equalizeColumn(Array.prototype.slice.call(cards));
  }

  function equalizeAll() {
    document
      .querySelectorAll('.vatpan-promo-mosaic__container')
      .forEach(equalizeContainer);
  }

  function scheduleEqualize() {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(equalizeAll);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleEqualize);
  } else {
    scheduleEqualize();
  }

  window.addEventListener('load', scheduleEqualize);
  window.addEventListener('resize', scheduleEqualize);

  if (typeof DESKTOP_MQ.addEventListener === 'function') {
    DESKTOP_MQ.addEventListener('change', scheduleEqualize);
  } else if (typeof DESKTOP_MQ.addListener === 'function') {
    DESKTOP_MQ.addListener(scheduleEqualize);
  }

  document.addEventListener('shopify:section:load', scheduleEqualize);
})();
